module.exports = __webpack_public_path__ + "img/rododo.4cd3f609.svg";